import React, { useState } from 'react'
import { useQuery } from 'convex/react'
import { api } from '../../convex/_generated/api'
import ErrorDisplay from './ErrorDisplay'

interface AdjustersDropdownProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  placeholder?: string
  style?: React.CSSProperties
}

const AdjustersDropdown: React.FC<AdjustersDropdownProps> = ({
  value,
  onChange,
  disabled = false,
  placeholder = 'Select an adjuster...',
  style = {}
}) => {
  const [showError, setShowError] = useState(false)
  
  let adjusters: any[] | undefined
  let error: any = null
  
  try {
    adjusters = useQuery(api.users.getUsersByRole as any, { role: 'adjuster' } as any) as any[] | undefined
  } catch (e) {
    error = e
  }

  // If there's an error and user needs to see adjusters, show error inline
  if (error && showError) {
    return (
      <div style={{ marginBottom: '16px' }}>
        <ErrorDisplay
          error={error}
          onRetry={() => window.location.reload()}
        />
      </div>
    )
  }

  // If there's an error but we haven't shown it yet, show a fallback dropdown
  if (error) {
    return (
      <div>
        <select
          value=""
          onChange={() => setShowError(true)}
          disabled={disabled}
          style={{
            ...style,
            backgroundColor: '#fef2f2',
            borderColor: '#fecaca',
            color: '#dc2626'
          }}
        >
          <option value="">Unable to load adjusters - Click to see details</option>
        </select>
      </div>
    )
  }

  // Loading state
  if (adjusters === undefined) {
    return (
      <select
        value=""
        disabled={true}
        style={{
          ...style,
          backgroundColor: '#f9fafb',
          color: '#6b7280'
        }}
      >
        <option value="">Loading adjusters...</option>
      </select>
    )
  }

  // Normal dropdown
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      style={style}
    >
      <option value="">{placeholder}</option>
      {adjusters.map((adjuster: any) => (
        <option key={adjuster._id} value={adjuster._id}>
          {adjuster.name} ({adjuster.email})
        </option>
      ))}
    </select>
  )
}

export default AdjustersDropdown